// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1d696a1e","455":"d4247d0e","977":"1e319f37"}[chunkId] + ".chunk.js";
};